module.exports = __webpack_public_path__ + "static/media/icon_success_modal.c40b458f.svg";